import {Component, HostBinding, Input, OnInit} from '@angular/core';
import {flatten} from 'lodash';
import {FlowMeterData, FlowMeterBatchDataLoader, Tractor} from 'shared';

@Component({
  selector: 'app-flow-meter-report',
  templateUrl: './flow-meter-report.component.html',
  styleUrls: ['./flow-meter-report.component.scss']
})
export class FlowMeterReportComponent implements OnInit {
  selectedTab = 0;
  @Input()
  loader: FlowMeterBatchDataLoader;
  flowMeterData: FlowMeterData;

  _selected: Tractor[];

  @Input()
  set selected(value: any[]) {
    if (!value) {
      this._selected = [];
    }
    this._selected = flatten(value.map(i => i.items));
  }

  @Input()
  width: number;

  childHeight: number;

  @HostBinding('style.height')
  hostHeight: number;

  @Input()
  set height(value: number) {
    this.hostHeight = value;
    this.childHeight = value - 38;
  }

  @HostBinding('style.width')
  get hostWidthStr() {
    return this.width + 'px';
  }

  @HostBinding('style.height')
  get hostHeightStr() {
    return this.hostHeight + 'px';
  }

  constructor() {
  }

  ngOnInit(): void {
  }


  selectTab(e: any) {
    this.selectedTab = e.itemIndex;
  }

}
